import React from "react";
import type { ShopifyApiVersion } from "state-trees/src/connections/shopify/ShopifyApiVersion";
import {
  eachShopifyModelMetadataForVersionWithModelKey,
  shopifyModelSpecForVersion,
} from "state-trees/src/connections/shopify/ShopifyModelMetadata";
import { isSyncOnlyModelKey } from "state-trees/src/connections/shopify/sync-only";
import { ListItem, UnorderedList } from "web/src/components/markdown/ListItems";

export const ShopifySyncOnlyModelsTable = (props: { apiVersion: ShopifyApiVersion; frameworkVersionConstraint: string }) => {
  const { apiVersion, frameworkVersionConstraint } = props;
  const modelNames: string[] = [];

  for (const [modelKey, _metadata] of eachShopifyModelMetadataForVersionWithModelKey(apiVersion, frameworkVersionConstraint)) {
    if (!isSyncOnlyModelKey(modelKey, apiVersion, frameworkVersionConstraint)) {
      continue;
    }
    const spec = shopifyModelSpecForVersion(modelKey, apiVersion, frameworkVersionConstraint);
    if (spec) {
      modelNames.push(spec.name);
    }
  }

  modelNames.sort((a, b) => a.localeCompare(b));

  return (
    <UnorderedList>
      {modelNames.map((name) => (
        <ListItem key={name}>{name}</ListItem>
      ))}
    </UnorderedList>
  );
};
